
export default {
  name: "CaixaResumoDropdown",

  props: {
    caixaAberto:   { type: Object,  default: null },
    resumo:        { type: Object,  default: null },
    operadorNome:  { type: String,  default: "" },
    terminalNome:  { type: String,  default: "" },
    pendentesSync: { type: Number,  default: 0 },
    sincronizando: { type: Boolean, default: false },
    online:        { type: Boolean, default: true },
    fechamentoAsCegas: { type: Boolean, default: false },
  },

  computed: {
    formasVendaList() {
      const vpf = this.resumo && this.resumo.vendas_por_forma;
      if (!vpf) return [];
      return Object.keys(vpf)
        .map((k) => ({ forma: k, valor: Number(vpf[k]) || 0 }))
        .filter((f) => f.valor > 0)
        .sort((a, b) => b.valor - a.valor);
    },
  },

  methods: {
    formatBRL(v) {
      const n = Number(v) || 0;
      return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    formatarData(iso) {
      if (!iso) return "—";
      const d = new Date(iso);
      return Number.isNaN(d.getTime())
        ? iso
        : d.toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });
    },
    _get(k) {
      return (this.resumo && Number(this.resumo[k])) || 0;
    },
  },
};
